<div class="emoji-modal" #modal>
  <div class="emoji-canvas" #canvas></div>
</div>
